// A tab opened before a deploy still runs the old build, whose page chunks and CSS are gone.
// Vite reports each failed load as `vite:preloadError`: reload once to pick up the new build
// instead of failing the navigation. A second failure soon after is a real error and surfaces.
const RELOADED_AT = 'sunny:stale-build-reload'
const WINDOW_MS = 30_000

type Target = Pick<Window, 'addEventListener' | 'location' | 'sessionStorage'>

export function reloadOnStaleBuild(target: Target, now: () => number = Date.now): void {
  target.addEventListener('vite:preloadError', (event) => {
    const last = read(target)
    if (last !== null && now() - last < WINDOW_MS) return
    if (!write(target, now())) return // Without a record we cannot stop a reload loop.
    event.preventDefault()
    target.location.reload()
  })
}

function read(target: Target): number | null {
  try {
    const value = Number(target.sessionStorage.getItem(RELOADED_AT))
    return Number.isFinite(value) && value > 0 ? value : null
  } catch {
    return null
  }
}

function write(target: Target, at: number): boolean {
  try {
    target.sessionStorage.setItem(RELOADED_AT, String(at))
    return true
  } catch {
    return false
  }
}
